/* eslint-disable react-hooks/exhaustive-deps */
import { useRef } from "react";
import ApexCharts from "apexcharts";

function TransmissionDetailChart({ graphData, serialNumber }) {
  const chartRef = useRef(null);
  const options = {
    series: [
      {
        name: "Measurement (m3)",
        type: "column",
        data:
          (graphData || [])?.length > 0
            ? graphData?.map((val) => val?.reading)
            : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        name: "Flow Rate (m3/h)",
        type: "line",
        data:
          (graphData || [])?.length > 0
            ? graphData?.map((val) => val?.flowRate)
            : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
    plotOptions: {
      bar: {
        columnWidth: 20,
        dataLabels: {
          position: "top",
          enabled: true,
          position: "center",
          textAnchor: "start",
          style: {
            fontSize: "10pt",
            colors: ["#000"],
          },
          offsetX: 0,
          horizontal: true,
          dropShadow: {
            enabled: false,
          },
        },
      },
    },
    colors: ["#6DBAE1", "#2F5E8A", "#ff0000"],
    chart: {
      height: 550,
      width: "100%",
      type: "line",
      stacked: true,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [1, 1],
      background: {
        enabled: true,
      },
    },
    stroke: {
      show: true,
      width: 3,
    },
    markers: {
      size: 5,
    },
    title: {
      text: serialNumber,
      align: "center",
      style: {
        fontSize: "18px",
        fontWeight: "400",
        color: "#5a5a5a",
      },
    },
    xaxis: { categories: graphData?.map((val) => val?.displayDate || " ") },
    yaxis: [
      {
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
          color: "#6dbae1",
        },
        labels: {
          style: {
            colors: "#959595",
          },
        },
        tooltip: {
          enabled: false,
        },
      },
      {
        tickAmount: 1,
        opposite: true,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
          color: "#6dbae1",
        },
        labels: {
          style: {
            colors: "#959595",
          },
        },
        tooltip: {
          enabled: false,
        },
      },
    ],
    legend: {
      markers: {
        width: 25,
        height: 15,
        radius: 0,
      },
      horizontalAlign: "center",
    },
    grid: {
      show: false,
    },
  };

  if (chartRef.current) {
    const chart = new ApexCharts(chartRef.current, options);
    chart.render();
  }

  return (
    <div
      className="w-full pt-10"
      // style={{ width: graphData.length * 25 + 'px' }}
    >
      <div id="chart" className="" ref={chartRef}></div>
    </div>
  );
}

export default TransmissionDetailChart;
